export default __webpack_public_path__ + "static/thought-test-79d42696b1e9f277e81128511210f28f.png";